// Update the logo carousel Swiper instance for mobile & tablet so multiple
// logos are visible at once instead of Elementor's default 1-per-view.

const BREAKPOINTS = [
  { maxWidth: 767,  slidesPerView: 4, spaceBetween: 16 },
  { maxWidth: 1024, slidesPerView: 6, spaceBetween: 20 },
];

function getSlidesConfig() {
  const w = window.innerWidth;
  for (const bp of BREAKPOINTS) {
    if (w <= bp.maxWidth) return bp;
  }
  return null; // desktop — leave Elementor's settings untouched
}

function patch(swiperEl) {
  const swiper = swiperEl.swiper;
  if (!swiper) return false;

  const config = getSlidesConfig();
  if (!config) return false;

  // Only re-patch if config changed (handles viewport resize)
  if (
    swiper.__ecwSlidesPerView === config.slidesPerView &&
    swiper.__ecwSpaceBetween  === config.spaceBetween
  ) return false;

  swiper.params.slidesPerView = config.slidesPerView;
  swiper.params.spaceBetween  = config.spaceBetween;
  swiper.update();

  swiper.__ecwSlidesPerView = config.slidesPerView;
  swiper.__ecwSpaceBetween  = config.spaceBetween;
  return true;
}

function patchAll() {
  let count = 0;
  document.querySelectorAll(
    '.ecw-logo-carousel .swiper, .ecw-logo-carousel .elementor-main-swiper'
  ).forEach(el => { if (patch(el)) count++; });
  return count;
}

export function initLogoCarouselMobile() {
  // Poll every 150 ms for up to 5 s after load — catches lazy-init carousels
  window.addEventListener('load', () => {
    let tries = 0;
    const id = setInterval(() => {
      if (patchAll() > 0 || ++tries > 33) clearInterval(id);
    }, 150);
  });

  // Re-patch on resize so crossing a breakpoint updates the slide count
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(patchAll, 200);
  }, { passive: true });

  // Elementor hook when available
  window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend?.hooks) {
      window.elementorFrontend.hooks.addAction(
        'frontend/element_ready/media-carousel.default',
        () => setTimeout(patchAll, 0)
      );
    }
  });
}
